module.exports = __webpack_public_path__ + "img/pig2.8f5a08e3.png";